import "../styles.scss";

import { Icons } from "components";
import MicOffIcon from "../icons/MicOffIcon";
//Icons
import MicOnIcon from "../icons/MicOnIcon";
import React from "react";
import Strings from "utils/strings";
import { Tooltip } from "antd";
import { connect } from "react-redux";

export class MenuBar extends React.Component<any, any> {
	getLocalAudioTrack = () => {
		const { audioRoom } = this.props;
		let audioTrack = null;
		const firstAudioTrack = audioRoom.localParticipant?.audioTracks;
		if (typeof firstAudioTrack?.values === "function") {
			for (const elem of firstAudioTrack.values()) {
				audioTrack = elem?.track;
				break;
			}
		} else if (typeof firstAudioTrack === "object") {
			const firstAudioKey = Object.keys(audioRoom.localParticipant?.audioTracks)[0];
			audioTrack = audioRoom.localParticipant?.audioTracks?.[firstAudioKey];
		}

		return audioTrack;
	};

	render() {
		const { audioRoom, showMobileOverlay } = this.props;

		let audioTrack: any = this.getLocalAudioTrack();

		return (
			<div className="AudioMenuBar">
				<Tooltip
					title={audioTrack?.isEnabled ? Strings.video.mute : Strings.video.unmute}
					placement="top"
					trigger={showMobileOverlay ? "" : "hover"}
				>
					<div
						className="AudioIconContainer"
						onClick={() => {
							if (!audioTrack) return;
							if (audioTrack?.isEnabled && typeof audioTrack?.disable === "function")
								audioTrack?.disable();
							else if (typeof audioTrack?.enable === "function") audioTrack?.enable();
							this.forceUpdate();
						}}
					>
						<div className="MenuOption">
							{audioTrack?.isEnabled ? <MicOnIcon audioTrack={audioTrack} /> : <MicOffIcon />}
						</div>
					</div>
				</Tooltip>
				<div className="AudioDisconnectContainer">
					<Tooltip
						title={Strings.video.disconnect}
						placement="top"
						trigger={showMobileOverlay ? "" : "hover"}
					>
						<div
							className="AudioIconContainer __circle __disconnect"
							onClick={() => {
								if (typeof audioRoom?.disconnect === "function") {
									audioRoom?.disconnect();
								}
							}}
						>
							<div className="MenuOption">
								<Icons.PhoneCall />
							</div>
						</div>
					</Tooltip>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => ({
	audioRoom: state.audioRoom
});

export default connect(mapStateToProps)(MenuBar);
